import { reportError } from 'utils/error'

export enum HeapEventType {
  Registration = 'Registration',
  CommandLine = 'CommandLine',
  AccessBlocked = 'AccessBlocked',
  Onboarding = 'Onboarding',
  SideStacking = 'SideStacking',
  ImportContacts = 'ImportContacts',
  SeoAnalysis = 'SeoAnalysis',
  ImportDocs = 'ImportDocs',
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  Payment = 'Payment',
  NewRegistration = 'NewRegistration',
  NewOnboarding = 'NewOnboarding',
}

export type HeapEventActions =
  | 'start'
  | 'end'
  | 'success'
  | 'failed'
  | 'skip_invites'
  | 'cancel_workspace_creation'
  | 'command_line_opened'
  | 'command_line_run'
  | 'doc_access_blocked'
  | 'google_contact_import_started'
  | 'google_contact_import_triage_started'
  | 'google_contact_import_finished'
  | 'google_docs_import_started'
  | 'google_docs_import_triage_started'
  | 'google_docs_import_finished'
  | 'handbook_access_blocked'
  | 'enter-email-google-complete'
  | 'verify-email-with-code-complete'
  | 'verify-email-with-code-failed'
  | 'create-account-complete'
  | 'create-account-failed'
  | 'select-role-complete'
  | 'select-use-case-complete'
  | 'select-use-case-failed'
  | 'invite-team-complete'
  | 'invite-team-failed'
  | 'onboarding-start'
  | 'onboarding-skip'
  | 'onboarding-finish'
  | 'onboarding-async'
  | 'onboarding-draft'
  | 'onboarding-review'
  | 'onboarding-organize'
  | 'start-drag'
  | 'drop'
  | 'select-node'
  | 'seo-analysis'
  | 'skip-secret-identity'
  | 'download-secret-identity'
  | 'share-secret-identity'
  | 'payment-failed-early'
  | 'payment-failed-late'
  | 'select-discovery-source-complete'
  | 'select-business-type-complete'
  | string

export type HeapEventProperties = {
  action: HeapEventActions
  type?: string
}

export const trackEventInHeap = (eventType: HeapEventType, properties: HeapEventProperties) => {
  try {
    window.heap?.track(eventType, properties)
  } catch (e) {
    reportError(e, {
      severity: 'error',
      metaData: { properties },
    })
  }
}
